import { MouseEventHandler } from "react";

export interface BtnProps {
    children: JSX.Element | JSX.Element[] | string;
    filled?: boolean;
    className?: string;
    onClick?: MouseEventHandler<HTMLButtonElement>;
    defaultStyle?: boolean;
    style?: object;
    noHoverEffect?: boolean;
    noBorder?: boolean;
    noBorderRadius?: boolean;
    noBgBlur?: boolean;
}

const defaultStyling = {
    padding: "15px 60px",
}

const Btn = ({ children, filled, className = '', defaultStyle = false, style = {}, noHoverEffect = false, noBorder = false, noBorderRadius = false, noBgBlur = false, ...props }: BtnProps): JSX.Element => {
    return (
        <button
            className={`
            ${noBgBlur ? '' : 'backdrop-blur-lg'}
            ${noBorder ? '' : 'border'} 
            ${noBorderRadius ? '' : 'rounded-full'} 
            border-darkblue 
            ${filled ? `bg-darkblue text-white ${!noHoverEffect && 'hover:text-darkblue hover:bg-transparent'}` : `text-darkblue ${!noHoverEffect && 'hover:text-white hover:bg-darkblue'}`} 
            ${className}
            `}
            {...props}
            style={
                {
                    ...(defaultStyle && { ...defaultStyling }),
                    ...style
                }
            }
        >
            {children}
        </button>
    )
}

export default Btn